import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { toPublicURL } from '@plone/volto/helpers';

const RERImmersiveReader = () => {
  const location = useLocation();
  const enabled = useSelector(
    (state) =>
      state.content?.data?.['@components']?.['immersive-reader']?.enabled,
  );

  const content = useSelector((state) => state.content?.data);

  const [ImmersiveReader, setImmersiveReader] = useState(null);

  const getTextForImmersiveReader = () => {
    let contentText = document?.getElementById(
      'main-content-section',
    )?.innerHTML;
    if (!contentText) {
      const pageDocument = document?.getElementById('page-document');
      if (pageDocument) {
        const clone = pageDocument.cloneNode(true);

        //ignore page header
        const toIgnore = clone.querySelectorAll('.PageHeaderWrapper');
        for (const ignore of toIgnore) {
          ignore.remove();
        }
        contentText = clone.innerHTML;
      }
      //contentText = document?.getElementById('page-document')?.innerHTML;
    }
    if (!contentText) {
      contentText = document?.getElementById(
        'faq-search-results-region',
      )?.innerHTML;
    }
    return contentText;
  };

  useEffect(() => {
    const initImmersiveReader = async () => {
      const immersiveReaderComponent = await import('./ImmersiveReader');
      if (typeof window === 'undefined') return;
      if (typeof document === 'undefined') return;

      setImmersiveReader(immersiveReaderComponent);
    };

    if (!ImmersiveReader && enabled) {
      initImmersiveReader();
    }
  }, [enabled]);

  return ImmersiveReader?.default ? (
    <>
      <ImmersiveReader.default
        getText={getTextForImmersiveReader}
        title={content.title}
      ></ImmersiveReader.default>
    </>
  ) : (
    <></>
  );
};

export default RERImmersiveReader;
